<template>
  <b-container fluid>
      <b-row v-if="!loader">
        <b-col lg="12" sm="12">
          <iq-card>
            <template>
                <b-row>
                    <b-col lg="12" sm="12">
                      <h5>{{ $t('rehabilitation_management.rules_policies') }} : </h5>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="12" sm="12">
                        <b-table-simple bordered small hover>
                            <b-tbody v-for="(item, index) in checklist" :key="index">
                                <b-tr>
                                    <b-th style="vertical-align: middle" width="30%" rowspan="2">{{ $n(index + 1) + '. ' + item.criteria_name }}</b-th>
                                    <b-th>
                                      <div style="font-weight: 400" v-for="(itm, indx) in item.checklist_details" :key="indx">
                                        <i class="fas fa-check-circle"></i> {{ itm.checklist_name }}
                                      </div>
                                    </b-th>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-col>
                </b-row>
            </template>
          </iq-card>
        </b-col>
      </b-row>
    </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
export default {
  props: ['id', 'checklist'],
  created () {
    if (this.id) {
      const tmp = this.getStockManageData()
       this.data = tmp
    }
  },
  mounted () {
    core.index()
  },
  data () {
    return {
    mainProps: { blank: true, blankColor: '#777', width: 75, height: 75, class: 'm1' },
     saveBtnName: this.$t('globalTrans.view'),
      data: {
        id: ''
      },
      approval: {
        items: [
          { id: 1, name: 'Hasinur' },
          { id: 2, name: 'Hasinur' },
          { id: 3, name: 'Hasinur' }
        ]
      },
      cropNameList: [],
      loader: false,
      search: {
        crop_name_id: 0
      }
    }
  },
  methods: {
    getStockManageData () {
      const tmpData = this.$store.state.list.find(item => item.id === this.id)
      return JSON.parse(JSON.stringify(tmpData))
    },
    getCropNameList (croptypeID) {
      const cropNameList = this.$store.state.SeedsFertilizer.commonObj.CropNameList.filter(item => item.status === 1)
      if (croptypeID) {
        return cropNameList.filter(cropName => cropName.crop_type_id === croptypeID)
      }
      return cropNameList
    }
  }
}
</script>
<style>
  .hidden_header {
    display: none
  }
  .card-border {
    border: 1px solid #b9bdc1;
    box-shadow: 1px 1px 6px -1px grey;
    background-color: #dee2e6;
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
  .report-name{
    font-weight: bold !important;
    text-transform: uppercase;
  }
  .my-btn{
    padding: 2px !important;
  }
</style>
